<template>
  <div class="country">
    <div class="label mb-2">ประเทศ</div>
    <el-select
      id="countries"
      v-model="countryCode"
      name="countries"
      placeholder="เลือกประเทศ"
      clearable
      filterable
    >
      <el-option
        v-for="item in countryOptions"
        :key="item.code"
        :label="item.name"
        :value="item.code"
      >
      </el-option>
    </el-select>
    <p
      v-if="!countryCode"
      style="color: red;
      font-size: 12px"
    >
      กรุณาเลือกประเทศ
    </p>
  </div>
</template>

<script>
export default {
  name: 'CountrySelector',
  props: {
    countryOptions: {
      type: Array,
      default: () => []
    },
    code: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      countryCode: this.code,
    };
  },
  watch: {
    code(val) {
      this.countryCode = val;
    },
    countryCode(val) {
      this.$emit('countrySelected', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.country {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 14px;
  color: #777;
}

.el-select {
  width: 250px;
}
</style>